export const about = [
  { label: "Our Story", link: "/our-story" },
  { label: "Mission and Values", link: "/mission" },
  { label: "History", link: "/history" },
  { label: "Our Facilities", link: "/our-facilities" },
  { label: "Spotlight on Staff", link: "/our-staff" },
  { label: "Contact Us", link: "/contact-us" },
];
export const admission = [
  { label: "welcome", link: "/welcome" },
  {
    label: "How to Apply",
    link: "/apply",
  },
  {
    label: "Tuition & Fees",
    link: "/fees",
  },
  {
    label: "Important Dates",
    link: "/important-dates",
  },
];
export const academics = [
  { label: "EYFS", link: "/eyfs" },
  { label: "Primary", link: "/primary" },
  { label: "Secondary", link: "/secondary" },
];
export const studentLife = [
  { label: "Boarding", link: "/boarding" },
  { label: "Clubs", link: "/clubs" },
  { label: "Events", link: "/events" },
];
